module.exports = __webpack_public_path__ + "static/media/third_slide.2f8bc7c0.jpg";